
import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";


import { ApiCallPost } from '../ApiCall/ApiCall';
import UpSpinner from './UpSpinner';

export default function UploadProcesados() {
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);
    const [files,setFiles] = useState( null ) ; // Aun no teenemos archivos cargados
    const [isLoading,setIsLoading] = useState( false )
    const [namefile, setnamefile] = useState('');


    const fileUploadRef = useRef(null);


    //  custom-cancel-btn

    function uploadTheData()
    {
        console.log( "Upload the Data " , files[0].name ) // uploadfileprocesado

        console.log( "namefile = " , namefile ) ;

        if ( namefile === "")
        {
            toast.current.show({ severity: 'warn', summary: 'Omisión', detail: 'No se selecciono Campaña' , life: 6000 });
 

            return ;
        }


        var reader = new FileReader()


        var theText = ""

        if (true) {
           reader.onload = async function (event) {
              theText = event.target.result;
              //console.log( theText )
              var retVal = await parseText( theText ) ;

              if ( !retVal )
              {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Registros no validos' , life: 6000 });
              }
              else{


                document.getElementsByClassName('custom-cancel-btn')[0].click()

        
                //setTotalSize(0);
                toast.current.show({ severity: 'info', summary: 'Success', detail: 'Archivo Cargado' });
        
                
              }
           }
        } else {
            console.log( "error")
           //preview.innerHTML = "<span class='error'>It doesn't seem to be a text file!</span>";
        }

        reader.readAsText(files[0]);

        


        return ;

        
    }

    function parseText( theFile )
    {

        return new Promise(( resolve,reject) => {

        
            var records = theFile.split( "\r\n") ;

            console.log( "Tenemos " + records.length + " registros ") ;

            var pos = theFile.indexOf( "|")

            if ( pos === -1 )
            {
                resolve( false );
            }

            setIsLoading( true )

            var obj = {
                records : records ,
                campain : namefile
            }



            ApiCallPost( "uploadfileprocesado2" , obj )
            .then(( response) => {
                console.log( response ) ;
                setIsLoading( false )
                resolve( true );
            })
            .catch((err) => {
                console.log( err ) ;

                setIsLoading( false )

                resolve( false );
            })

        })


    }
    
    const onTemplateSelect = (e) => {

        console.log( "onTempleteSelect")

        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);

        setFiles( files )
    };

    const onTemplateUpload = (e) => {

        console.log( "onTemplate upload")

        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        console.log( "onTempleteClear")
        setTotalSize(0);
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 100000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}


                <div className="card flex justify-content-center">
                    <FloatLabel>
                        <InputText id="username" value={namefile} onChange={(e) => setnamefile(e.target.value)} />
                        <label htmlFor="username">Campaña</label>
                    </FloatLabel>
                </div>

                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 10 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Arrastre y Suelte archivo aqui
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    return (
        <div>
            <Toast ref={toast}></Toast>

            <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
            <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
            <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

            <div className='flex justify-content-center'>
                <h3>Carga Datos Procesados</h3>

            </div>



            {
                isLoading === true && (
                    <UpSpinner></UpSpinner>
                )

            }
            

            <FileUpload ref={fileUploadRef} name="demo[]"   url="/api/upload"  accept=".txt;.csv;.jpg" maxFileSize={10000000}
                onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                chooseOptions={chooseOptions} customUpload={true} uploadHandler={uploadTheData} 
                uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
        </div>
    )
}
        